<div class="crm-scroll flex h-full flex-col overflow-auto bg-white text-slate-900">
  <header class="flex items-center gap-3 border-b !border-slate-200 p-4">
    <app-icon class="text-orange-600">history</app-icon>
    <div class="min-w-0 flex-1">
      <h2 class="!m-0 !text-lg !font-semibold">{{ (selectedShift ? 'prro.receipts' : 'prro.provider_history') | translate }}</h2>
      <p class="!m-0 text-sm text-slate-500">{{ registerName }}</p>
      @if (selectedShift) {
        <p class="!mb-0 !mt-1 break-all text-xs text-slate-500">{{ 'prro.shift_id' | translate }}: <span class="select-text font-mono">{{ selectedShift }}</span></p>
      }
    </div>
    <app-button btnType="icon" [ariaLabel]="'close' | translate" (onChangeClick)="close.emit()"><app-icon>close</app-icon></app-button>
  </header>
  <div class="flex flex-1 flex-col gap-3 p-4">
    @if (selectedShift && !shiftId) {
      <app-button btnType="stroked" [disabled]="loading" (onChangeClick)="showShifts()">{{ 'prro.previous' | translate }}</app-button>
    }
    @if (loading) {
      <p class="text-sm text-slate-500">{{ 'prro.loading' | translate }}</p>
    } @else if (error) {
      <p class="text-sm text-red-700">{{ error | translate }}</p>
      <app-button btnType="stroked" (onChangeClick)="load()">{{ 'prro.retry' | translate }}</app-button>
    } @else {
      @for (item of items; track $index) {
        <section class="overflow-hidden rounded-xl border !border-slate-200 bg-white">
          <div class="flex flex-wrap items-start gap-3 p-4">
            <div class="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-orange-50 text-orange-600">
              <app-icon class="!flex !h-5 !w-5 !text-[20px] !leading-none">{{ item.icon }}</app-icon>
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex flex-wrap items-center gap-2">
                <h3 class="!m-0 !text-sm !font-semibold">{{ item.title | translate }}</h3>
                <app-tag [tag]="{ id: item.status, name: item.status | translate, color: item.color }" [compact]="true" [maxCharacters]="40" [icon]="item.statusIcon" />
              </div>
              @if (item.reference) {
                <p class="!mb-0 !mt-1 break-all font-mono text-xs text-slate-600">{{ item.reference }}</p>
              }
              <p class="!mb-0 !mt-1 text-xs text-slate-500">{{ item.date }}</p>
            </div>
            <div class="ml-auto flex shrink-0 items-center gap-1">
              @if (item.url) {
                <a class="inline-flex h-9 w-9 items-center justify-center rounded-lg !text-orange-600 !no-underline hover:bg-orange-50" [href]="item.url" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'prro.receipt_link' | translate" [matTooltip]="'prro.receipt_link' | translate"><app-icon class="!flex !h-5 !w-5 !text-[20px] !leading-none">open_in_new</app-icon></a>
              }

              <app-button btnType="icon" customClass="!inline-flex !h-9 !w-9 !items-center !justify-center !rounded-lg !p-0 !text-slate-500 hover:!bg-slate-100" [ariaLabel]="(!item.shift && item.operationId ? 'prro.details' : 'prro.history_technical_data') | translate" [matTooltip]="(!item.shift && item.operationId ? 'prro.details' : 'prro.history_technical_data') | translate" (onChangeClick)="toggleDetails(item)"><app-icon class="!flex !h-5 !w-5 !text-[20px] !leading-none">{{ expanded.has(item) ? 'expand_less' : 'info' }}</app-icon></app-button>
            </div>
          </div>
          @if (item.report) {
            <aside class="border-t !border-amber-100 bg-amber-50 px-4 py-3 text-sm text-amber-900">
              <div class="flex items-start gap-2">
                <app-icon class="mt-0.5 !flex !h-4 !w-4 shrink-0 !text-base !leading-none">info</app-icon>
                <div>
                  <h4 class="!m-0 !text-sm !font-semibold">{{ item.title | translate }}</h4>
                  @if (item.record['type'] === 'z_report') {
                    <p class="!mb-0 !mt-1 text-xs leading-relaxed">{{ 'prro.report_hint' | translate }}</p>
                  }
                  <a class="mt-3 inline-flex items-center justify-center gap-2 rounded-lg border !border-amber-200 bg-white px-3 py-2 text-xs font-medium !text-amber-900 !no-underline hover:bg-amber-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600" href="https://kasa.vchasno.ua/" target="_blank" rel="noopener noreferrer">
                    {{ 'prro.open_vchasno_account' | translate }}<app-icon class="!flex !h-4 !w-4 !items-center !justify-center !text-base !leading-none">open_in_new</app-icon>
                  </a>
                </div>
              </div>
            </aside>
          }
          @if (item.shift) {
            <div class="grid grid-cols-2 gap-3 border-t !border-slate-100 bg-slate-50 px-4 py-3 text-sm">
              <div><p class="!m-0 text-xs text-slate-500">{{ 'prro.history_closed_at' | translate }}</p><span class="tabular-nums">{{ item.closedAt }}</span></div>
              <div><p class="!m-0 text-xs text-slate-500">{{ 'prro.balance' | translate }}</p><span class="tabular-nums">{{ item.balance === null ? '—' : (item.balance | number: '1.2-2') }}</span></div>
              <app-button class="col-span-2" btnType="stroked" (onChangeClick)="showChecks(item.record)">{{ 'prro.receipts' | translate }}</app-button>
            </div>
          } @else if (item.amount !== null) {
            <div class="flex justify-between border-t !border-slate-100 px-4 py-3 text-sm"><span class="text-slate-500">{{ 'amount' | translate }}</span><strong class="tabular-nums">{{ item.amount | number: '1.2-2' }}</strong></div>
          }
          @if (expanded.has(item)) {
            <div class="border-t !border-slate-100 bg-slate-50 p-4">
              <h4 class="!m-0 !mb-3 !text-xs !font-medium text-slate-500">{{ 'prro.history_technical_data' | translate }}</h4>
              <pre class="!m-0 max-h-96 overflow-auto whitespace-pre-wrap break-words rounded-lg border !border-slate-200 bg-white p-3 text-xs text-slate-600">{{ item.record | json }}</pre>
            </div>
          }
        </section>
      } @empty {
        <div class="flex flex-col items-center gap-2 rounded-xl bg-slate-50 p-8 text-slate-400"><app-icon>receipt_long</app-icon><p class="!m-0 text-sm">{{ 'prro.empty_journal' | translate }}</p></div>
      }
    }
  </div>
  <footer class="flex items-center justify-end gap-3 border-t !border-slate-200 p-4">
    <span class="text-sm text-slate-500">{{ page }}</span>
    <app-button btnType="stroked" [disabled]="loading || !history?.has_prev" (onChangeClick)="load(-1)">{{ 'prro.previous' | translate }}</app-button>
    <app-button btnType="stroked" [disabled]="loading || !history?.has_next" (onChangeClick)="load(1)">{{ 'prro.next' | translate }}</app-button>
  </footer>
</div>
